// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation_Confirmation__3_2FU","title":"Confirmation_title__3_BlB","content":"Confirmation_content__H9xD6","toHome":"Confirmation_toHome__1dRu4"};